<template>
  <div class="categories-icons">
      <div v-for="category in categories.listIcons"  class="category-icon">
        <div class="content" @click="selected(category)">
          <img :src="category.imageList[0]" class="img-fluid"/>
          <p>{{category.name}}</p>
          <div class="content-hover"></div>
        </div>
      </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    computed: {
      ...mapState({
        categories: state => state.categories,
      }),
    },
    methods: {
      selected(category) {
        this.$store.dispatch('categories/selected', {category:category, top:true});
        this.$emit('selected');
        this.$router.replace({ name: 'searchPage'});
      }
    },
    beforeMount() {
      this.$store.dispatch('categories/requestData');
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/categories/src/CategoriesIcon.vue